import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import toast from 'react-hot-toast';
import { FiUser, FiMail, FiLock, FiBriefcase, FiEye, FiEyeOff } from 'react-icons/fi';

const RegisterPage = () => {
  const [form, setForm] = useState({ nama: '', email: '', password: '', confirmPassword: '', organisasi: '', jabatan: '' });
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirmPassword) return toast.error('Password tidak cocok');
    if (form.password.length < 6) return toast.error('Password minimal 6 karakter');
    setLoading(true);
    try {
      await register(form);
      toast.success('Registrasi berhasil!');
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Registrasi gagal');
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-page">
      <div className="auth-card" style={{ maxWidth: 480 }}>
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <div style={{ width: 56, height: 56, borderRadius: 14, background: 'linear-gradient(135deg, var(--primary-600), var(--primary-400))', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 800, fontSize: '1.3rem', marginBottom: '1rem' }}>N</div>
        </div>
        <h2>Daftar Akun</h2>
        <p className="auth-subtitle">Bergabung dengan portal NGADHU</p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label"><FiUser style={{ marginRight: 4 }} size={13} /> Nama Lengkap</label>
            <input className="form-input" name="nama" placeholder="Masukkan nama lengkap" value={form.nama} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label className="form-label"><FiMail style={{ marginRight: 4 }} size={13} /> Email</label>
            <input className="form-input" name="email" type="email" placeholder="nama@email.com" value={form.email} onChange={handleChange} required />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
            <div className="form-group">
              <label className="form-label"><FiBriefcase style={{ marginRight: 4 }} size={13} /> Organisasi</label>
              <input className="form-input" name="organisasi" placeholder="Nama OPD/Instansi" value={form.organisasi} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label className="form-label">Jabatan</label>
              <input className="form-input" name="jabatan" placeholder="Jabatan Anda" value={form.jabatan} onChange={handleChange} />
            </div>
          </div>
          <div className="form-group">
            <label className="form-label"><FiLock style={{ marginRight: 4 }} size={13} /> Password</label>
            <div style={{ position: 'relative' }}>
              <input className="form-input" name="password" type={showPw ? 'text' : 'password'} placeholder="Minimal 6 karakter" value={form.password} onChange={handleChange} required style={{ paddingRight: '2.5rem' }} />
              <button type="button" onClick={() => setShowPw(!showPw)} style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: 'var(--gray-400)', cursor: 'pointer' }}>{showPw ? <FiEyeOff /> : <FiEye />}</button>
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Konfirmasi Password</label>
            <input className="form-input" name="confirmPassword" type="password" placeholder="Ulangi password" value={form.confirmPassword} onChange={handleChange} required />
          </div>
          <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%', justifyContent: 'center' }} disabled={loading}>
            {loading ? 'Memproses...' : 'Daftar'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: '1.5rem', fontSize: '0.85rem', color: 'var(--gray-500)' }}>
          Sudah punya akun? <Link to="/login" style={{ color: 'var(--primary-600)', fontWeight: 600 }}>Masuk di sini</Link>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
